import { inject, Injectable } from '@angular/core';
import { SquareCatalogItemEndpoints } from 'app/core/enums/endpoints/gateway.enum';
import { ApiService } from 'app/services/api/api.service';
import { Observable } from 'rxjs';
import {
    LoadSquareCatalogItemsParams,
    SquareCatalogItemPayload,
} from '../../types';

@Injectable({
    providedIn: 'root',
})
export class SquareCatalogItemService {
    private _endpoint = SquareCatalogItemEndpoints;
    private _apiService = inject(ApiService);

    constructor() {}

    // ------------------------------------------------------------------
    // @ CRUD methods
    // ------------------------------------------------------------------

    getAll(params: LoadSquareCatalogItemsParams): Observable<any> {
        return this._apiService.getWithQueryParams(this._endpoint.getAll, {
            gateway_id: params.gatewayId,
            // code: params.code,
            // category_id: params.categoryId,
            // search: params.search,
        });
    }

    getOne(id: number): Observable<any> {
        return this._apiService.getOne(this._endpoint.getOne, id);
    }

    create(data: SquareCatalogItemPayload): Observable<any> {
        return this._apiService.post(this._endpoint.create, data);
    }

    update(data: SquareCatalogItemPayload, squareId: string): Observable<any> {
        return this._apiService.update(this._endpoint.update, data, squareId);
    }

    delete(squareId: string, params: { gatewayId: number }): Observable<any> {
        return this._apiService.deleteWithQueryParams(
            `${this._endpoint.delete}/${squareId}`,
            {
                gateway_id: params.gatewayId,
            }
        );
    }
}
